import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminForgotPassword } from "../services/api";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400&family=Playfair+Display:wght@400;500;600;700&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .fp-root {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'DM Sans', sans-serif;
    background: #f7f5ff;
    padding: 24px;
    position: relative;
    overflow: hidden;
  }
  .fp-root::before {
    content: '';
    position: absolute; inset: 0;
    background:
      radial-gradient(ellipse 340px 240px at 95% 5%,  rgba(168,85,247,0.10) 0%, transparent 70%),
      radial-gradient(ellipse 300px 300px at 5%  95%, rgba(109,40,217,0.08) 0%, transparent 70%);
    pointer-events: none;
  }

  .fp-card {
    width: 420px;
    max-width: 100%;
    background: #ffffff;
    border-radius: 24px;
    box-shadow: 0 24px 70px rgba(76,29,149,0.16);
    padding: 40px;
    position: relative;
    z-index: 1;
  }

  .fp-icon-circle {
    width: 58px; height: 58px;
    border-radius: 50%;
    background: linear-gradient(135deg, rgba(109,40,217,0.12), rgba(168,85,247,0.12));
    border: 1px solid rgba(168,85,247,0.25);
    display: flex; align-items: center; justify-content: center;
    margin: 0 auto 20px;
  }

  .fp-heading {
    font-family: 'Playfair Display', serif;
    font-size: 30px; font-weight: 700;
    color: #1f1035; text-align: center;
    letter-spacing: -0.5px; margin-bottom: 10px;
  }
  .fp-subhead {
    font-size: 13.5px; color: #4C1D95;
    text-align: center; font-weight: 400;
    line-height: 1.6; opacity: 0.75;
    margin-bottom: 28px;
  }

  .fp-alert {
    width: 100%; padding: 11px 15px; border-radius: 12px;
    font-size: 13px; font-weight: 500;
    display: flex; align-items: center; gap: 8px; margin-bottom: 20px;
    line-height: 1.5; word-break: break-word;
  }
  .fp-alert.error   { background: #fff4f4; color: #b83030; border: 1px solid rgba(184,48,48,0.15); }
  .fp-alert.success { background: #f0fdf4; color: #15803d; border: 1px solid rgba(21,128,61,0.18); }

  .fp-field { width: 100%; margin-bottom: 20px; }
  .fp-label {
    display: block; font-size: 11px; font-weight: 700;
    color: #4C1D95; letter-spacing: 2px;
    text-transform: uppercase; margin-bottom: 8px;
  }
  .fp-input-wrap {
    position: relative; display: flex; align-items: center;
    background: #f5f3ff; border: 1.5px solid #DDD6FE;
    border-radius: 13px; padding: 0 14px;
    transition: all 0.22s ease;
  }
  .fp-input-wrap:focus-within {
    border-color: #6D28D9; background: #ffffff;
    box-shadow: 0 0 0 4px rgba(109,40,217,0.1), 0 4px 16px rgba(109,40,217,0.08);
  }
  .fp-input {
    flex: 1; padding: 14px 0; border: none;
    background: transparent; color: #1f1035;
    font-size: 14px; font-family: 'DM Sans', sans-serif;
    font-weight: 400; outline: none; letter-spacing: 0.1px;
  }
  .fp-input::placeholder { color: #C4B5FD; font-weight: 300; }

  .fp-btn {
    width: 100%; padding: 15px;
    background: linear-gradient(135deg, #6D28D9 0%, #A855F7 100%);
    border: none; border-radius: 13px;
    color: white; font-weight: 600; font-size: 14px;
    font-family: 'DM Sans', sans-serif;
    cursor: pointer; letter-spacing: 1.8px; text-transform: uppercase;
    position: relative; overflow: hidden;
    transition: transform 0.18s, box-shadow 0.18s, opacity 0.18s;
    box-shadow: 0 10px 32px rgba(109,40,217,0.38);
  }
  .fp-btn:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 16px 44px rgba(109,40,217,0.52);
  }
  .fp-btn:active:not(:disabled) { transform: translateY(0); }
  .fp-btn:disabled { opacity: 0.62; cursor: not-allowed; }
  .fp-btn::after {
    content: ''; position: absolute; top: 0; left: -100%;
    width: 60%; height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
    transition: left 0.5s;
  }
  .fp-btn:hover::after { left: 160%; }
  .fp-btn-inner {
    display: flex; align-items: center;
    justify-content: center; gap: 10px; position: relative; z-index: 1;
  }
  .fp-spinner {
    width: 16px; height: 16px;
    border: 2.5px solid rgba(255,255,255,0.3);
    border-top-color: white; border-radius: 50%;
    animation: spin 0.7s linear infinite; flex-shrink: 0;
  }
  @keyframes spin { to { transform: rotate(360deg); } }

  .fp-footer {
    margin-top: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6px;
    font-size: 12.5px;
    color: #4C1D95;
    padding-top: 20px;
    border-top: 1px solid #EDE9FE;
  }
  .fp-footer a {
    color: #6D28D9; text-decoration: none;
    font-weight: 600; cursor: pointer; transition: color 0.15s;
  }
  .fp-footer a:hover { color: #4C1D95; }

  @media (max-width: 480px) {
    .fp-card { padding: 30px 24px; }
    .fp-heading { font-size: 26px; }
  }
`;

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState({ type: "", text: "" });
  const [submitted, setSubmitted] = useState(false);

  const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      setMsg({ type: "error", text: "Please enter your admin email address." });
      return;
    }
    if (!isValidEmail(email)) {
      setMsg({ type: "error", text: "Please enter a valid email address." });
      return;
    }

    try {
      setLoading(true);
      setMsg({ type: "", text: "" });

      const res = await adminForgotPassword({ email });

      // ✅ We NEVER read or display a reset link from the response.
      // The backend intentionally only ever returns a generic message —
      // the actual link only exists inside the admin's email inbox.
      setMsg({
        type: "success",
        text: res.data.message || "If that email is registered, a password reset link has been sent to it.",
      });
      setSubmitted(true);
    } catch (error) {
      let backendMsg;
      if (!error.response) {
        backendMsg = "Cannot connect to the server. Make sure the backend is running on port 5000.";
      } else {
        backendMsg =
          error.response.data?.message ||
          "Something went wrong. Please try again in a moment.";
      }
      setMsg({ type: "error", text: backendMsg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{CSS}</style>
      <div className="fp-root">
        <div className="fp-card">
          <div className="fp-icon-circle">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#6D28D9" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="5" width="18" height="14" rx="2" />
              <path d="M3 7l9 6 9-6" />
            </svg>
          </div>

          <div className="fp-heading">Forgot Password</div>
          <div className="fp-subhead">
            Enter your admin email and we'll send a reset link to help you sign in again.
          </div>

          {msg.text && <div className={`fp-alert ${msg.type}`}>{msg.text}</div>}

          {!submitted && (
            <form onSubmit={handleSubmit} autoComplete="off">
              <div className="fp-field">
                <label className="fp-label">Email Address</label>
                <div className="fp-input-wrap">
                  <input
                    type="email"
                    className="fp-input"
                    placeholder="admin@blackBoards.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoComplete="off"
                  />
                </div>
              </div>

              <button className="fp-btn" type="submit" disabled={loading}>
                <span className="fp-btn-inner">
                  {loading ? (
                    <><span className="fp-spinner" />Sending…</>
                  ) : (
                    "Send Reset Link"
                  )}
                </span>
              </button>
            </form>
          )}

          <div className="fp-footer">
            <span>Remembered your password?</span>
            <a onClick={() => navigate("/admin/login")}>Back to login</a>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;